export default __webpack_public_path__ + "locales/pl/Common.json?hash=a2589a9c731fd1d69e7c6c20168f1483";